// pages/FormViewerPage/services/formViewerService/variantValidation.ts — varian wajib dipilih
// Aturan 2026-10-05 (order kaos salah ukuran): dropdown diam-diam terisi values[0]
// + submit lolos tanpa warning. Sekarang tiap opsi tampil HARUS dipilih eksplisit
// (prefill URL/lead/default editor tetap dihitung sebagai pilihan).
// Key error: `variant:<namaOpsi>` — dirender di bawah dropdown oleh VariantOptions.

export interface VariantOptionLike {
    name: string;
    values: string[];
}

export function validateVariantFields(
    displayOptions: VariantOptionLike[] | null | undefined,
    selectedOptions: Record<string, string> | null | undefined,
): Record<string, string> {
    const errors: Record<string, string> = {};
    for (const opt of displayOptions || []) {
        const picked = String(selectedOptions?.[opt.name] || '').trim();
        if (!picked || !(opt.values || []).includes(picked)) {
            errors[`variant:${opt.name}`] = `Wajib pilih ${opt.name}`;
        }
    }
    return errors;
}
